import { NgModule } from '@angular/core';
import {CommonModule} from "@angular/common";

import { FilterPipe } from './filter.pipe';
import { SearchPipe } from './search.pipe';
import { ShortNamePipe } from './short-name.pipe';
import { EnumToArrayPipe } from './enum-to-array.pipe';
import { EnumStringToArrayPipe } from './enum-string-to-array.pipe';

@NgModule({
  declarations:[FilterPipe, SearchPipe, ShortNamePipe, EnumToArrayPipe, EnumStringToArrayPipe],
  imports:[CommonModule],
  exports:[FilterPipe, SearchPipe, ShortNamePipe, EnumToArrayPipe,EnumStringToArrayPipe]
})

export class PipeModule{}
